import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { Table, cn } from 'twyne-new.ui';

import Body from './Body';
import { Header } from './Header';
import NoContent from './NoContent';
import { TableProvider, useTableContext } from './context';
import { handleMouseMove, useStopResizing } from './hooks';

const DefaultTableResize = props => <TableProvider>
  <DefaultTableResizeContent {...props} />
</TableProvider>

const DefaultTableResizeContent = ({ columns, data, noDataIndication, rowClassName, keyField, className = '', rowWrapper, footer, sticky = true, fixedFistColumnOnScroll = false }) => {
  const { columnWidths, setColumnWidths, setActiveResizeColumn, setResizedColumns } = useTableContext()
  const dragStateRef = useRef(null)
  const columnsKey = useMemo(
    () => columns.map((column, index) => `${column.id || column.dataField || index}:${column.dataField || ''}:${column.headerClassName || ''}`).join('|'),
    [columns],
  )
  const onMouseMove = useCallback(event => {
    handleMouseMove({ event, dragStateRef, setColumnWidths })
  }, [setColumnWidths])

  const stopResizing = useStopResizing({ dragStateRef, setActiveResizeColumn, onMouseMove })
  useEffect(() => {
    stopResizing()
    setColumnWidths({})
    setResizedColumns([])
  }, [columnsKey, setColumnWidths, setResizedColumns, stopResizing])
  const hasManualSizing = Object.keys(columnWidths).length > 0

  return <div className='relative overflow-x-auto'>
    <Table className={cn('w-full', hasManualSizing && 'table-fixed')} containerClassName={className}>
      <Header
        columns={columns}
        sticky={sticky}
        fixedFistColumnOnScroll={fixedFistColumnOnScroll}
        dragStateRef={dragStateRef}
        onMouseMove={onMouseMove}
        stopResizing={stopResizing}
      />
      {data && data.length ? <>
        <Body
          data={data}
          columns={columns}
          rowClassName={rowClassName}
          keyField={keyField}
          rowWrapper={rowWrapper}
          fixedFistColumnOnScroll={fixedFistColumnOnScroll}
        />
      </> : null}
      {footer}
    </Table>
    <NoContent data={data} noDataIndication={noDataIndication} />
  </div>
}

export default DefaultTableResize
